import styled from "styled-components";

export const TransactionModalContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.25);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0%;
  right: 0%;
  margin-top: 0% !important;
  z-index: 5000;
  .messageBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    max-width: 820px;
    max-height: 644px;
    overflow-y: scroll;
    padding-top: 1rem;
    border-radius: 10px;
    margin: auto;
    margin-top: 10rem;
    padding-bottom: 1rem;
    .content {
      padding: 2rem;
      margin: 1rem;
      margin-top: 0%;
      div {
        direction: rtl;
        p {
          direction: rtl;
          text-align: right !important;
          strong {
          }
        }
      }
      .switchMode {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 1rem auto;
        & > span {
          font-size: 0.75rem;
          margin: 0 0.5rem;
          color: #2f2f2f;
        }
        .switch {
          position: relative;
          display: inline-block;
          width: 40px;
          height: 16px;
        }

        /* Hide default HTML checkbox */
        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        /* The slider */
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgb(108, 174, 255);
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 12px;
          width: 12px;
          left: 5px;
          bottom: 2px;
          background-color: white;
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }

        input:checked + .slider {
          /* background-color: #73af99; */
        }

        input:checked + .slider:before {
          -webkit-transform: translateX(20px);
          -ms-transform: translateX(20px);
          transform: translateX(20px);
        }

        /* Rounded sliders */
        .slider.round {
          border-radius: 16px;
        }

        .slider.round:before {
          border-radius: 50%;
        }
      }
    }
    .displayResult {
      display: flex;
      border: 2px dashed gray;
      padding: 1rem;
      border-radius: 10px;
      margin-bottom: 1rem;
      &.valid {
        border: 2px dashed rgb(108, 174, 255);
      }
      & > div {
        margin: 0 2rem;
        & > span {
          color: #2f2f2f;
        }
      }
    }
    .sendRequest {
      margin-bottom: 1rem;
      scale: 0.8;
    }
    .timePeriod {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .timeBox {
        margin-bottom: 1rem;
        & > span {
          display: block;
          color: #343434;
          margin-bottom: 1rem;
          & > span {
            font-size: 0.8rem;
          }
        }
        .inputs {
          input {
            border: unset;
            background-color: #e7e7e762;
            padding: 0.5rem;
            border-radius: 10px;
            margin-right: 0.5rem;
            border: 1px solid white;
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
            &.error {
              border: 1px solid red;
            }
          }
        }
      }
    }
    .title {
      color: black;
      color: rgb(108, 174, 255);
      font-size: 1.5rem;
      font-weight: 500;
      margin-top: 0.3rem;
      margin-bottom: 1rem;
      margin-bottom: 0%;
    }
    p {
      direction: rtl;
      padding: 1rem;
      padding-top: 0%;
      font-size: 1.1rem;
      text-align: center;
    }
    .btns {
      display: flex;
      margin-bottom: 2rem;
      a {
        width: 150px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgb(109, 151, 203);
        border-radius: 8px;
        border-width: 1px;
        border-color: rgb(108, 174, 255);
        border-style: solid;
        color: #fff;
        padding-right: 8px;
        padding-left: 8px;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 21px;
        text-align: center;
        word-wrap: break-word;
        cursor: pointer;
        -webkit-transition: 0.7s;
        transition: 0.7s;
        color: white;
        pointer-events: unset;
        &.disabled {
          background-color: gray;
          opacity: 0.5;
          border-color: gray;
          cursor: not-allowed;
          pointer-events: none;
        }
      }
      & > button {
        background-color: white;
        color: rgb(108, 174, 255);
        margin-left: 1rem;
      }
    }
  }
  @media (max-width: 700px) {
    .messageBox {
      margin: 1rem;
    }
    .inputs {
      display: flex;
      flex-direction: column;
      input {
        text-align: center;
      }
    }
  }
`;
